import lodash from "lodash";
import moment from "moment";
import i18n from "../../i18n";
import { dateFormat } from "../../utils/date";

export const createOnCallChangeLog = ({ props, data }) => {
    return () => {
        data.loading.setIsLoading(true);
        props
            .onCallChangeLog({ id: props.id, page: data.changeLogPage.page, size: data.changeLogPage.size })
            .then(page => (data.changeLogPage = page))
            .finally(() => data.loading.setIsLoading(false));
    };
};

export const createMapping = ({ props }) => {
    return changeLog => {
        return props.mappings
            .filter(mapping => mapping?.changeLog || mapping?.key)
            .map(mapping => {
                return {
                    ...mapping,
                    value: mapping.changeLog?.getValue
                        ? mapping.changeLog.getValue({ record: changeLog, field: mapping })
                        : lodash.get(changeLog, mapping.key)
                };
            })
            .filter(
                mapping =>
                    mapping.value !== undefined && (!Array.isArray(mapping.value) || (Array.isArray(mapping.value) && mapping.value.length > 0))
            );
    };
};

export const createPagination = ({ data, onCallChangeLog }) => {
    return {
        current: data.changeLogPage.page + 1,
        pageSize: data.changeLogPage.size,
        total: data.changeLogPage.totalSize,
        pageSizeOptions: ["1", "5", "10", "20"],
        showSizeChanger: true,
        size: "small",
        align: "right",
        showTotal: (total, range) => {
            return i18n.global.t("components.table.pagination.total", { total, range0: range[0] || 0, range1: range[1] || 0 });
        },
        onShowSizeChange: (current, size) => {
            data.changeLogPage.page = current - 1;
            data.changeLogPage.size = size;
            onCallChangeLog();
        },
        onChange: (page, pageSize) => {
            data.changeLogPage.page = page - 1;
            data.changeLogPage.size = pageSize;
            onCallChangeLog();
        }
    };
};

export const getValue = ({ value }) => {
    if (moment(value, true, ['YYYY-MM-DD', 'YYYY-MM-DD[T]HH:mm:ss[Z]']).isValid()) {
        if (value?.length > 10) return dateFormat({ text: value, format: "DD/MM/YYYY HH:mm:ss" });
        else return dateFormat({ text: value, format: "DD/MM/YYYY" });
    }
    return value;
};
